import { render } from "./CommonNotification.vue?vue&type=template&id=2d568a74"
import script from "./CommonNotification.vue?vue&type=script&lang=js"
export * from "./CommonNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__